import React, { useState } from 'react';
import { TFunction } from 'i18next';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
    toggleInstallContactModal,
    setSelectedProductID,
    setSelectedInstallBaseID
} from '../../actions/manageInventoryActions';
import ManageReportModal from '../manageReport/ManageReportModal';
import InstallContactModal from '../manageInventory/InstallContactModal';

interface EquipmentActionsCardProps {
    t: TFunction;
    installBaseID: string;
    productID: string;
    contacts?: {
        serviceSales: string;
        equipmentSales: string;
        leadTechnician1: string;
        leadTechnician2: string;
        emergencyNumber: string;
    };
}

const EquipmentActionsCard: React.FC<EquipmentActionsCardProps> = ({
    t,
    installBaseID,
    productID,
    contacts
}) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [showDailyRoundsModal, setShowDailyRoundsModal] = useState(false);

    const handleAssetPhotos = () => {
        history.push(`/asset_photos?installbaseId=${installBaseID}`);
    };

    const handleServiceReports = () => {
        history.push(`/documents?installbaseId=${installBaseID}`);
    };

    const handleDailyRounds = () => {
        setShowDailyRoundsModal(true);
    };

    const handleRequestService = () => {
        dispatch(setSelectedProductID(productID));
        dispatch(setSelectedInstallBaseID(installBaseID));
        dispatch(toggleInstallContactModal());
    };

    return (
        <div className="equipment-actions-section">
            <h3>{t('common:actions')}</h3>
            <div className="equipment-actions-card">
                <div className="equipment-actions-content">
                    <div className="equipment-services-section">
                        <h4 className="equipment-actions-section-label">
                            {t('dashboardAnalytics:services')}
                        </h4>
                        <div className="equipment-actions-buttons">
                            <button
                                className="btn btn-primary equipment-action-button"
                                onClick={handleAssetPhotos}
                            >
                                {t('tiles:assetPhotos')}
                            </button>
                            <button
                                className="btn btn-primary equipment-action-button"
                                disabled
                            >
                                {t('dashboardAnalytics:futureCTA')}
                            </button>
                            <button
                                className="btn btn-primary equipment-action-button"
                                onClick={handleServiceReports}
                            >
                                {t('dashboardAnalytics:serviceReports')}
                            </button>
                            <button
                                className="btn btn-primary equipment-action-button"
                                onClick={handleDailyRounds}
                            >
                                {t('manageMeasurementPointLists:dailyRounds')}
                            </button>
                            <button
                                className="btn btn-primary equipment-action-button"
                                onClick={handleRequestService}
                            >
                                {t('dashboardAnalytics:requestService')}
                            </button>
                        </div>
                    </div>

                    <hr />

                    <div className="equipment-contacts-section">
                        <h4 className="equipment-actions-section-label">
                            Contacts
                        </h4>
                        <div className="equipment-contacts">
                            <div className="equipment-contact-row">
                                <span className="contact-label">
                                    Emergency Number:
                                </span>
                                <span className="contact-value">
                                    {contacts?.emergencyNumber || 'N/A'}
                                </span>
                            </div>
                            <div className="equipment-contact-row">
                                <span className="contact-label">
                                    Service Sales:
                                </span>
                                <span className="contact-value">
                                    {contacts?.serviceSales || 'N/A'}
                                </span>
                            </div>
                            <div className="equipment-contact-row">
                                <span className="contact-label">
                                    Equipment Sales:
                                </span>
                                <span className="contact-value">
                                    {contacts?.equipmentSales || 'N/A'}
                                </span>
                            </div>
                            <div className="equipment-contact-row">
                                <span className="contact-label">
                                    Lead Technician #1:
                                </span>
                                <span className="contact-value">
                                    {contacts?.leadTechnician1 || 'N/A'}
                                </span>
                            </div>
                            <div className="equipment-contact-row">
                                <span className="contact-label">
                                    Lead Technician #2:
                                </span>
                                <span className="contact-value">
                                    {contacts?.leadTechnician2 || 'N/A'}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ManageReportModal
                forDailyRounds={true}
                selectedTemplate={undefined}
                className="first-modal"
                show={showDailyRoundsModal}
                title={'Daily Rounds Report'}
                closeModal={() => setShowDailyRoundsModal(false)}
                onHide={() => setShowDailyRoundsModal(false)}
            />

            <InstallContactModal colorButton="warning" />
        </div>
    );
};

export default EquipmentActionsCard;
